import {
  call,
  put,
  takeEvery,
  delay
} from "redux-saga/effects";
import {
  FETCH_CASHBACK_START,
} from "./actionTypes";
import {
  fetchCashbackFailed,
  fetchCashbackSuccess,
} from "./action";
import * as transApis from "apis/transactions";


function * fetchCashback(params){
  try {
    const data = yield call(transApis.getCashbackTransactions, params);
    yield put(fetchCashbackSuccess(data));
  } catch (error){
    yield put(fetchCashbackFailed());
  } 
}


function * cashbackSaga(){
  yield takeEvery(FETCH_CASHBACK_START, fetchCashback);
}
export default cashbackSaga;